@if (!supplierToEdit && !editProfile) {
<div class="loader" role="status" aria-label="Cargando prestador"></div>
}
<section class="scr-page">
  @if (supplierToEdit || editProfile) {
  <tp-page-header
    [title]="(supplierToEdit && supplierToEdit.fullName) || 'Nuevo prestador'"
    [subtitle]="editProfile ? 'Perfil del prestador · edición' : 'Perfil del prestador'"
  >
    @if (supplierToEdit && !editProfile) {
    <button mat-flat-button actions class="scr-btn-primary" (click)="editSupplierProfile()"
      [disabled]="!usrSvc.hasPermission('add:contractor')">
      <mat-icon>edit</mat-icon>
      Editar datos
    </button>
    }
  </tp-page-header>
  }

  @if (supplierToEdit) {
  <div class="scr-card scr-card--padded" [hidden]="editProfile">
    <h2 class="scr-section-title">Datos personales</h2>
    <dl class="data-list">
      <div class="data-list__item">
        <dt>Nombre completo</dt>
        <dd>{{ supplierToEdit.fullName }}</dd>
      </div>
      <div class="data-list__item">
        <dt>Email</dt>
        <dd>{{ supplierToEdit.email }}</dd>
      </div>
      <div class="data-list__item">
        <dt>DNI</dt>
        <dd>{{ supplierToEdit.dni }}</dd>
      </div>
      <div class="data-list__item">
        <dt>Fecha de nacimiento</dt>
        <dd>{{ supplierToEdit.birthDate | date : "dd/MM/yyyy" }}</dd>
      </div>
      @for (phone of supplierToEdit.phones; track phone) {
      <div class="data-list__item">
        <dt>Teléfono</dt>
        <dd>{{ phone?.number }}</dd>
      </div>
      }
    </dl>
    @if (supplierToEdit.addresses) {
    <div class="addresses">
      @for (address of supplierToEdit.addresses; track address; let i = $index) {
      <div class="address">
        <div class="address__head" role="button" tabindex="0" [attr.aria-expanded]="i === expandedIndex"
          (click)="toggleVisibility(i)" (keyup)="keyOnAddress($event, i)">
          <mat-icon class="chevron">{{ i === expandedIndex ? "expand_more" : "chevron_right" }}</mat-icon>
          <span class="address__title">Domicilio</span>
          <span class="address__summary">{{ address.street }} {{ address.number }}</span>
        </div>
        @if (i === expandedIndex) {
        <div class="address__body">
          <dl class="data-list data-list--stacked">
              <div class="data-list__item">
                <dt>País</dt>
                <dd>{{ getCountryName(address.countryId) }}</dd>
              </div>
              <div class="data-list__item">
                <dt>Provincia</dt>
                <dd>{{ getStateName(address.stateId) }}</dd>
              </div>
              <div class="data-list__item">
                <dt>Localidad</dt>
                <dd>{{ getLocationName(address.cityId) }}</dd>
              </div>
              <div class="data-list__item">
                <dt>Barrio</dt>
                <dd>{{ address.neighborhood }}</dd>
              </div>
              <div class="data-list__item">
                <dt>Calle</dt>
                <dd>{{ address.street }}</dd>
              </div>
              <div class="data-list__item">
                <dt>Altura</dt>
                <dd>{{ address.number }}</dd>
              </div>
              <div class="data-list__item">
                <dt>Mza</dt>
                <dd>{{ address.block }}</dd>
              </div>
              <div class="data-list__item">
                <dt>Lote</dt>
                <dd>{{ address.parcel }}</dd>
              </div>
              <div class="data-list__item">
                <dt>Piso</dt>
                <dd>{{ address.floor }}</dd>
              </div>
              <div class="data-list__item">
                <dt>Dpto</dt>
                <dd>{{ address.deparment }}</dd>
              </div>
              <div class="data-list__item">
                <dt>Observaciones</dt>
                <dd>{{ address.notes }}</dd>
              </div>
          </dl>
          <div class="map-container">
            <indu-map [markers]="disableCoordinates ? [] : addressPointer" [center]="center" [zoom]="16"
              [draggable]="false">
            </indu-map>
          </div>
        </div>
        }
      </div>
      }
    </div>
    }
  </div>
  }

  <div class="scr-card scr-card--padded" [hidden]="!editProfile">
    <form [formGroup]="supplierForm" (keydown.enter)="$event.preventDefault()" autocomplete="off" class="edit-form">
      <h2 class="scr-section-title">Datos personales</h2>
      <div class="scr-form-grid">
        <div class="scr-field">
          <label for="sp-fullName">Nombre completo</label>
          <input id="sp-fullName" class="tp-input" matInput placeholder="Nombre completo" name="fullName"
            formControlName="fullName" required maxlength="170" autocomplete="off" />
          @if (supplierForm.get('fullName')?.touched && supplierForm.get('fullName')?.hasError('required')) {
          <mat-error>Campo obligatorio.</mat-error>
          }
          @if (supplierForm.get('fullName')?.hasError('pattern')) {
          <mat-error>
            El nombre no puede contener números ni caracteres especiales.
          </mat-error>
          }
        </div>
        <div class="scr-field">
          <label for="sp-email">Email</label>
          <input id="sp-email" class="tp-input" matInput maxlength="100" placeholder="correo@email.com" name="email"
            formControlName="email" required autocomplete="off" />
          @if (supplierForm.get('email')?.touched && supplierForm.get('email')?.hasError('required')) {
          <mat-error>Campo obligatorio.</mat-error>
          }
          @if (supplierForm.get('email')?.hasError('pattern')) {
          <mat-error>
            El email no tiene un formato válido (por ejemplo, nombre@empresa.com.ar).
          </mat-error>
          }
        </div>
        <div class="scr-field">
          <label for="sp-dni">DNI</label>
          <input id="sp-dni" class="tp-input" matInput min="0" max="99999999" type="number"
            onKeyPress="if(this.value.length==8) return false;" placeholder="DNI" name="dni" formControlName="dni"
            autocomplete="off" required (keydown)="validateOnlyNumbers($event)" />
          @if (supplierForm.get('dni')?.touched && supplierForm.get('dni')?.hasError('required')) {
          <mat-error>Campo obligatorio.</mat-error>
          }
          @if (supplierForm.get('dni')?.hasError('pattern')) {
          <mat-error>
            El DNI debe contener entre 7 a 8 dígitos.
          </mat-error>
          }
        </div>
        <div class="scr-field">
          <label for="sp-birthDate">Fecha de nacimiento</label>
          <div class="date-container">
            <input id="sp-birthDate" matInput class="tp-input date" [matDatepicker]="picker"
              formControlName="birthDate" required [max]="maxDate" autocomplete="off" />
            <mat-datepicker-toggle class="calendar-icon" matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </div>
          @if (supplierForm.get('birthDate')?.touched && supplierForm.get('birthDate')?.hasError('required')) {
          <mat-error>Campo obligatorio.</mat-error>
          }
          @if (supplierForm.get('birthDate')?.hasError('validateBirthDate')) {
          <mat-error>
            La fecha de nacimiento no puede ser en el futuro.
          </mat-error>
          }
        </div>
        <div class="scr-field" formArrayName="phones">
          <div class="scr-field" [formGroupName]="0">
            <label for="sp-phone-0">Teléfono principal</label>
            <input id="sp-phone-0" class="tp-input" matInput required min="0" max="9999999999" type="number"
              onKeyPress="if(this.value.length==10) return false;" placeholder="Número" name="number"
              formControlName="number" autocomplete="off" (keydown)="validateOnlyNumbers($event)" />
            @if (supplierForm.get('phones')?.get('0')?.get('number')?.touched && supplierForm.get('phones')?.get('0')?.get('number')?.hasError('required')) {
            <mat-error>Campo obligatorio.</mat-error>
            }
            @if (
            supplierForm
            .get('phones')
            ?.get('0')
            ?.get('number')
            ?.hasError('pattern')
            ) {
            <mat-error>
              El teléfono no puede contener menos de 10 dígitos.
            </mat-error>
            }
          </div>
        </div>
        <div class="scr-field" formArrayName="phones">
          <div class="scr-field" [formGroupName]="1">
            <label for="sp-phone-1">Teléfono alternativo</label>
            <input id="sp-phone-1" class="tp-input" matInput min="0" max="9999999999" type="number"
              onKeyPress="if(this.value.length==10) return false;" placeholder="Número" name="number"
              formControlName="number" autocomplete="off" (keydown)="validateOnlyNumbers($event)" />
            @if (
            supplierForm
            .get('phones')
            ?.get('1')
            ?.get('number')
            ?.hasError('pattern')
            ) {
            <mat-error>
              El teléfono no puede contener menos de 10 dígitos.
            </mat-error>
            }
          </div>
        </div>
      </div>

      <div class="address-header">
        <h3 class="scr-section-title">Domicilio legal</h3>
      </div>
      <div class="address-edit">
        <div class="address-edit__form">
          <app-address [form]="supplierForm" [alias]="lAddress"></app-address>
        </div>
        <div class="address-edit__map">
          <div class="address-edit__map-action">
            <button type="button" class="map-link" (click)="addPointerMarker()" [disabled]="disableCoordinates">
              <mat-icon>place</mat-icon> Buscar ubicación en el mapa
            </button>
          </div>
          <div class="map-container">
            <indu-map [markers]="disableCoordinates ? [] : addressPointer" [center]="center" [zoom]="17"
              (markerDragendEvent)="markerDragend($event)" [draggable]="true">
            </indu-map>
          </div>
        </div>
      </div>
      <div class="match-toggle">
        <mat-slide-toggle formControlName="addressesMatch">
          Coinciden dirección personal y legal
        </mat-slide-toggle>
        <div [@Expand-Collapse]="
            !supplierForm.controls['addressesMatch'].value
              ? 'expand'
              : 'collapse'
          ">
          <h3 class="scr-section-title real-address-title">Dirección real</h3>
          <app-address [form]="supplierForm" [alias]="pAddress" className="col-lg-6"></app-address>
        </div>
      </div>
    </form>
    <div class="scr-form-actions">
      <button mat-flat-button class="scr-btn-primary" (click)="onSubmit()"
        [disabled]="!usrSvc.hasPermission('edit:client')">
        Guardar cambios
      </button>
    </div>
  </div>

  @if (supplierToEdit) {
    <app-supplier-skills
      id="skills"
      [supplier]="supplierToEdit"
      (moveToSectionTrigger)="moveToSection()"
    ></app-supplier-skills>
  }
  @if (supplierToEdit) {
    <app-supplier-workingDays
      id="working-days"
      [supplier]="supplierToEdit"
    ></app-supplier-workingDays>
  }
  @if (supplierToEdit) {
    <app-supplier-profile-vehicle
      id="vehicles"
      [supplier]="supplierToEdit"
    ></app-supplier-profile-vehicle>
  }
  @if (supplierToEdit) {
    <app-supplier-profile-assistant
      id="colaborators"
      [supplier]="supplierToEdit"
    ></app-supplier-profile-assistant>
  }
  @if (supplierToEdit) {
    <app-supplier-working-areas
      id="working-area"
      [supplier]="supplierToEdit"
    ></app-supplier-working-areas>
  }
</section>
